import { SpellList } from "../../data/spells";
import { Actor } from "./Actor";

export const getMissingRequirements = (spell: any, actor: Actor) => {
  const result = [];
  if (spell.requires) {
    for (const requirement of spell.requires) {
      if (!actor.book.find((bookSpell) => bookSpell.id === requirement)) {
        result.push(
          SpellList.find((spellData) => spellData.id === requirement)?.name
        );
      }
    }
  }
  return result;
};
export const hasRequirements = (spell: any, actor: Actor) => {
  if (spell.requires) {
    for (const requirement of spell.requires) {
      if (!actor.book.find((bookSpell) => bookSpell.id === requirement)) {
        return false;
      }
    }
  }
  return true;
};
